// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__aCa7_","skeleton_animate":"styles_skeleton_animate__ODl29"};